import React from 'react'
import classes from '../styles/App.module.css'

const Header = () => {
    return (
        <>
            <div className={`row ${classes.header}`}>
                <div className={`col-12 ${classes.title}`}>
                    <p>
                        Our website in under construction
                    </p>
                </div>

                <div className={`col-12 ${classes.message}`}>
                    <h2>We are coming soon</h2>
                    <p>
                        Our website is being developed to provide you with the best experience. Please subscribe with your active email address for get notified when we launch.
                    </p>
                </div>

            </div>
        </>
    )
}

export default Header